import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-432659d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center title-wrapper" }
const _hoisted_2 = { class: "step" }
const _hoisted_3 = { class: "title" }


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    step: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.step), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1)
  ]))
}
}

})